import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setSessionUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setSessionUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-bg gap-4">
      <Loader2 className="w-8 h-8 animate-spin text-brand-blue" />
      <p className="text-brand-muted">Entrando...</p>
    </div>
  );
}
